export const styles = theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  label: {
    color: theme.palette.primary.steelGrey,
  },
  listItem: {
    color: theme.palette.primary.formItem,
  },
  dropdownButton: {
    width: 10,
  },
  modalText: {
    padding: theme.spacing(),
  },
  modal: {
    position: 'absolute',
    top: '25%',
    left: '25%',
    width: '50%',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.primary.white,
  },
});
